import styled from "@emotion/styled";
import { TableCell, TableRow, Typography } from "@mui/material";
import { FaFilter, FaPencil, FaTrashCan } from "react-icons/fa6";

import { colors } from "../../../styles/colors";
import fontWeight from "../../../styles/mui/fontWeight";
import { NoRecordsCell } from "../../../app/styles/styles";

export const InputStyle = {
  borderRadius: "0.0625rem",
  borderColor: colors.black[13],
  width: "16rem",
  height: "2.4rem",
  "& .MuiOutlinedInput-root": {
    height: "2.4rem",
    "& input": {
      marginLeft: "0.7rem",
      height: "2.4rem",
      borderRadius: "0.0625rem",
      padding: "0",
      width: "100% !important",
      fontSize: "0.8rem",
    },
    "&.Mui-focused fieldset": {
      borderColor: colors.black[13],
    },
    "&.Mui-error fieldset": {
      borderColor: colors.black[13],
    },
  },
};

export const SelectInputStyle = {
  borderColor: colors.black[13],
  width: "16rem",
  height: "2.4rem",
  "& .MuiOutlinedInput-root": {
    height: "2.4rem",
    "& input": {
      marginLeft: "0.417rem",
      height: "2.4rem",
      borderRadius: "0.0625rem",
      padding: "0",
      fontSize: "0.8rem",
    },
    "&:hover fieldset": {
      borderColor: colors.black[13],
    },
    "&.Mui-focused fieldset": {
      borderColor: colors.black[13],
    },
  },
};

export const UserCountStyle = (colorBg: string, color: string) => ({
  padding: "10px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  width: "170px",
  height: "70px",
  backgroundColor: colorBg,
  borderLeft: `solid ${color} 4px`,
  borderRadius: "0 10px 10px 0",
});

export const InputSearchStyle = {
  marginLeft: "15px",
  borderRadius: "1px",
  borderColor: colors.black[13],
  width: "20rem",
  height: "2rem",
  "& .MuiOutlinedInput-root": {
    height: "2rem",
    "& input": {
      marginLeft: "0.417rem",
      height: "2rem",
      borderRadius: "1px",
      padding: "0",
    },
    "&.Mui-focused fieldset": {
      borderColor: colors.black[13],
    },
    "&.Mui-error fieldset": {
      borderColor: colors.black[13],
    },
  },
};

export const AddUserModalBox = (isAdminAccess?: boolean) => ({
  width: isAdminAccess ? "50%" : "70%",
  backgroundColor: colors.white[1],
  borderRadius: 1,
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  boxShadow: 24,
  p: 2,
});

export const ContentScrollable = () => ({
  backgroundColor: colors.white[1],
  borderRadius: 1,
  padding: 2,
  maxHeight: "70vh",
  overflowY: "auto",
  "&::-webkit-scrollbar": {
    width: "7px",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#888",
    borderRadius: "6px",
  },
  "&::-webkit-scrollbar-thumb:hover": {
    backgroundColor: "#555",
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "#f1f1f1",
    borderRadius: "6px",
  },
});

export const AddUserModalGrid = () => ({
  marginTop: "0.9rem",
});

export const AddUserInputStyle = {
  borderRadius: "1px",
  borderColor: colors.black[13],
  width: "430px",
  "& .MuiOutlinedInput-root": {
    "& input": {
      marginLeft: "0.417rem",
      borderRadius: "1px",
      padding: "0",
    },
    "&.Mui-focused fieldset": {
      borderColor: colors.black[13],
    },
    "&.Mui-error fieldset": {
      borderColor: colors.black[13],
    },
  },
};

export const AutocompleteTextStyle = {
  "& .MuiChip-root": {
    borderRadius: "5px",
    height: "22px",
    fontSize: "11px",
    margin: "5px",
    padding: "0px 0px",
  },
  "& .MuiInputBase-root": {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    minHeight: "36px",
    overflowY: "auto",
  },
};

export const RoleInputStyle = {
  borderRadius: "1px",
  borderColor: colors.black[13],
  height: "18px",
  width: "430px",
  "& .MuiOutlinedInput-root": {
    height: "18px",
    "& input": {
      marginLeft: "0.417rem",
      height: "18px",
      borderRadius: "1px",
      padding: "0",
    },
    "&.Mui-focused fieldset": {
      borderColor: colors.black[13],
    },
    "&.Mui-error fieldset": {
      borderColor: colors.black[13],
    },
  },
};
export const FaPencilIcon: any = styled(FaPencil as React.ComponentType)(() => ({
  marginRight: "0.75rem",
  color: colors.primary.main,
  fontSize: "1rem",
  cursor: "pointer",
}));
export const FaTrashCanIcon: any = styled(FaTrashCan as React.ComponentType)(() => ({
  marginRight: "0.75rem",
  color: colors.red[100],
  fontSize: "1rem",
  cursor: "pointer",
}));

export const DropDownMaxWidth = () => ({
  maxWidth: "11.5rem",
});

export const AutocompleteDropDownMaxWidth = () => ({
  maxWidth: "90%",
});

export const PhoneNumberInputStyle = {
  borderRadius: "0.0625rem",
  borderColor: colors.black[13],
  width: "16rem",
  "& .MuiInputBase-root.MuiInput-root": {
    marginTop: 0,
  },
  "& .MuiInputBase-input.MuiInput-input": {
    WebkitBoxShadow: "none",
    padding: "0.2rem 0 .35rem 0.7rem",
    border: `0.0625rem solid ${colors.black[13]}`,
    borderRadius: "4px",
    height: "1.6rem",
    fontSize: "0.8rem",
  },
  "& .MuiInputBase-root.MuiInput-root:before": {
    borderBottom: 0,
  },
  "&::before": {
    borderBottom: 0,
  },
  "&::after": {
    borderBottom: 0,
  },
  "& .MuiInputBase-root.MuiInput-root:after": {
    borderBottom: 0,
  },
};

export const GridContainer = () => ({
  height: "4.5rem",
});

export const HeaderInputFieldWidth = () => ({
  maxWidth: "15rem",
  padding: "0 2rem 0 0",
});

export const VerifyUser = () => ({
  padding: " 0 0 0 0 ",
});

export const FilterByHeaderStyle = {
  width: "100%",
  backgroundColor: "#FFFF",
  padding: 2,
  borderRadius: "5px",
};

export const ModalContainer = () => ({
  position: "relative",
  width: "30%",
  backgroundColor: "background.paper",
  padding: "1rem",
  border: `1px solid ${colors.grey[1]}`,
  overflowY: "auto"
});

export const MainContainer = {
  display: "flex",
  flexDirection: "column",
  maxWidth: "100%",
  minWidth: "100%",
  paddingRight: 1,
  minHeight: "60vh",
  maxHeight: "60vh",
};

export const ProviderListingHeader = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    borderRadius: 1.5,
    backgroundColor: colors.white[1],
}

export const TextGridStyle = {
  color: colors.fonts[1],
  fontWeight: fontWeight[3],
  whiteSpace: "normal",
  wordBreak: "break-word",
};

export const IconFilter: any = styled(FaFilter as React.ComponentType)({
  display: "flex",
  flexDirection: "row",
  alignItems: "flex-start",
  fontSize: "1.0rem",
  justifyContent: "left",
  color: colors.fonts[18],
  margin: "1.0rem 0.72rem 0 0.72rem",
});

export const FilterIcon = {
  display: "flex",
  flexDirection: "row",
  alignItems: "flex-start",
};

export const FilterText = {
  "& .MuiToggleButton-root": {
    height: 35,
    textTransform: "none",
  },
}

export const ModalGrid = () => ({
  marginTop: "0.9rem",
});

export const ConfirmationModalBox = () => ({
  backgroundColor: colors.backgroundColor[1],
  borderRadius: 1,
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  boxShadow: 24,
  p: 2,
});

export const ConfirmationModalGrid = () => ({
  marginBottom: "0.4rem",
  display: "flex",
  alignItems: "center",
});

export const GridRowStyle = () => ({
  display: "flex",
  flexDirection: "row",
  paddingTop: 1,
  minWidth: "8rem",
});


export const NoRecordFound = (id: string) => {
  return id === "0" ? (
    <TableRow>
      <TableCell align="center" colSpan={14}>
        <Typography
          variant="subtitle1"
          fontWeight={fontWeight[3]}
          color={colors.fonts[4]}
          sx={NoRecordsCell}
        >
          NO RECORDS FOUND
        </Typography>
      </TableCell>
    </TableRow>
  ) : (
    <></>
  );
};